export default __webpack_public_path__ + "static/media/26.eae7b984.png";